var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crpg-a-common-item-number code"},[_c('span',{staticClass:"subtitle"},[_vm._v("商品番号")]),_vm._v("ライフ：No."+_vm._s(_vm.itemNumber)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }